// src/features/aws-user/auth.ts
import { Auth } from 'aws-amplify';
import {AppDispatch, resetAppState} from '@app/store';
import { riotApi } from './api';

export const resetUserState = async (dispatch: AppDispatch) => {
  try {
    // First reset any existing API state
    dispatch(riotApi.util.resetApiState());

    // Reset Redux state
    dispatch(resetAppState());

    // Clear any localStorage/sessionStorage if needed
    localStorage.clear(); // Or remove specific items if you prefer

    // Sign out from Cognito - use global to clear all sessions
    await Auth.signOut({ global: true });

  } catch (error) {
    console.error('Error during reset user state:', error);
    // You might want to throw this error to handle it in the component
    throw error;
  }
};
